import React, { useState } from 'react';
import theme from './LoginForm.module.scss';
import { requestPasswordReset } from '@/services/users';
import { Trans } from '@lingui/react/macro';
import { ValidationForm, ValidationSummary } from '@/components/forms/validation';
import UserPageInput from './UserPageInput';
import SplashPage from './SplashPage';
import { CustomLink } from '@/components/navigation';
import { Button as RubusButton } from '@ygtechnologies/rubus-ui';

interface OwnProps { }

const ForgotPassword: React.FC<OwnProps> = () => {
    const [email, setEmail] = useState('');
    const [saving, setSaving] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        setSaving(true);

        try {
            await requestPasswordReset(email);
            setSuccess(true);
        } finally {
            setSaving(false);
        }
    };

    if (success) {
        return (
            <SplashPage>
                <Trans>
                    If the email address is registered in Rucoria, you will receive an email with a password reset link within
                    a few minutes.
                    <b>Please note:</b>
                    <ul>
                        <li>
                            The link expires after <b>2 hours</b> and you can only use it <b>once</b>
                        </li>
                    </ul>
                    Didn't recieve the email?
                    <ul>
                        <li>Check your spam folder</li>
                        <li>Verify which email address you are registered with in Rucoria (with your project)</li>
                        <li>Otherwise, check with your project/vendor which email address is registered for you in Rucoria</li>
                    </ul>
                </Trans>
                <br />
                <CustomLink to="/">
                    <Trans>Back to sign in page</Trans>
                </CustomLink>
            </SplashPage>
        );
    }

    return (
        <SplashPage>
            <h3 className={theme.header}>
                <Trans>Forgot Password</Trans>
            </h3>

            <ValidationForm onSubmit={handleFormSubmit}>
                <p className={theme.centeredText}>
                    <Trans>Enter your email address and we’ll send you a link you can use to reset your password.</Trans>
                </p>
                <UserPageInput
                    label={<Trans>Email</Trans>}
                    required
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <ValidationSummary />

                <RubusButton size="lg" iconPosition="right" type="submit" variant="primary" loading={saving} block>
                    <Trans>Reset password</Trans>
                </RubusButton>
                <CustomLink className={theme.textLink} to="/login">
                    <Trans>Back to login page</Trans>
                </CustomLink>
            </ValidationForm>
        </SplashPage>
    );
};

export default ForgotPassword;
